import { render, staticRenderFns } from "./DarkReconForumManager.vue?vue&type=template&id=52f06e41&scoped=true"
import script from "./DarkReconForumManager.vue?vue&type=script&lang=js"
export * from "./DarkReconForumManager.vue?vue&type=script&lang=js"
import style0 from "./DarkReconForumManager.vue?vue&type=style&index=0&id=52f06e41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f06e41",
  null
  
)

export default component.exports